import { useEffect } from 'react';

/**
 * **손가락이 닿은 문서** (2026-09-10 실기 · Android PWA). 첫 `touchstart` 에 `<html data-touch="on">` 을
 * 적는다 — 그 뒤로 `:hover` 규칙은 성립하지 않는다(`styles.css` 의 그 블록). 터치 기기는 탭한 요소에
 * 호버를 다음 탭까지 남기고, 기기가 `(hover: hover)` 를 어떻게 답하든 그 사실은 같다.
 *
 * 한 번 적으면 지우지 않는다 — 태블릿에 마우스를 꽂는 경우의 호버 손실은 감수한다(그쪽은 표시일
 * 뿐이고 이쪽은 「눌린 채 남는」 결함이다). DOM 을 만지는 자리는 이 훅 하나다.
 */
export function useTouchInput(): void {
  useEffect(() => {
    const mark = () => {
      document.documentElement.dataset['touch'] = 'on';
    };
    window.addEventListener('touchstart', mark, { once: true, passive: true });
    return () => {
      window.removeEventListener('touchstart', mark);
    };
  }, []);
}
